import { createLucideIcon } from 'lucide-react';
export const ToastSuccessIcon = createLucideIcon('foobar', [
  [
    'path',
    {
      d: 'M11.7536 3.00336C9.56337 3.06336 7.47027 3.92026 5.86678 5.41338',
      key: 'rcjx6n',
    },
  ],
  [
    'path',
    {
      d: 'M16.2967 19.9081C18.2219 18.8621 19.6995 17.1497 20.4522 15.092',
      key: 'd4bfse',
    },
  ],
  [
    'path',
    {
      d: 'M17 4.49999C15.317 3.09699 13.944 2.94299 11.754 3.00299',
      key: '1u4319',
    },
  ],
  [
    'path',
    {
      d: 'M20.452 15.092C21.205 13.034 21.296 11.541 20.5 9.5',
      key: '151zwt',
    },
  ],
  [
    'path',
    {
      d: 'M3.04375 11.1137C2.82797 13.294 3.41498 15.4782 4.69471 17.2567',
      key: '15oxaq',
    },
  ],
  [
    'path',
    {
      d: 'M4.6947 17.2567C5.97442 19.0351 7.85896 20.2857 9.99491 20.7738',
      key: '1vr641',
    },
  ],
  [
    'path',
    {
      d: 'M5.86677 5.41339C4.26328 6.9065 3.25953 8.93328 3.04375 11.1137',
      key: 'f9qthj',
    },
  ],
  [
    'path',
    {
      d: 'M7 12.1923L10.4737 16L19 7',
      key: '12dnuu',
    },
  ],
  [
    'path',
    {
      d: 'M9.99492 20.7738C12.1309 21.2619 14.3715 20.9541 16.2967 19.9081',
      key: '1w0w2e',
    },
  ],
]);
